import { Observable } from 'rxjs';
import { UseCase } from '../../../base/use-case';
import { ConfigurationRepository } from '../../../repositories/configuration.repository';
import { DataDemoBusinessEntity } from '../../../../data/repositories/configuration/entities/company/demo-business.entity';
import { DemoBusinessModel } from '../../../models/configuration/company/demo-business.model';

export class InsertDemoBusinessUseCase
  implements UseCase<DataDemoBusinessEntity, DemoBusinessModel>
{
  constructor(private Repository: ConfigurationRepository) {}
  execute(params: DataDemoBusinessEntity): Observable<DemoBusinessModel> {
    return this.Repository.insertDemoBusiness(params);
  }
}
